export const DTP_STATUS = {
  SCHEDULED: "Scheduled",
  CANCELLED: "Cancelled",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  COMPLETED: "Completed",
  LIVE: "Live",
  TEMPLATE: "Template",
  DRAFT: "Draft",
};
export const DTP_ACTION = {
  activateSummary: "activateSummary",
  activateConfirmation: "activateConfirmation",
  scheduleSummary: "scheduleSummary",
  activateTemplate: "activateTemplate",
  templateConfirmation: "templateConfirmation",
};
